import { render, staticRenderFns } from "./OptionsItem.vue?vue&type=template&id=4b8b611f&"
import script from "./OptionsItem.vue?vue&type=script&lang=js&"
export * from "./OptionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports